import { joinURL, parseURL } from 'ufo'
import { defineProvider } from '@nuxt/image/runtime'

/** media.gokonfetti.com/{id}/{width}x0/{filename}.webp */
const WIDTH_SEGMENT = /^\/(\d+)\/(\d+)x0\/(.+)$/i

/** Max width 910 plus three smaller tiers (only these appear in URLs). */
const WIDTH_RUNGS = [360, 540, 720, 910] as const

function snapToKonfettiWidth (raw: number): number {
  const w = Math.max(1, Math.round(raw))
  for (const rung of WIDTH_RUNGS) {
    if (w <= rung) {
      return rung
    }
  }
  return WIDTH_RUNGS[WIDTH_RUNGS.length - 1]
}

export default defineProvider<{ baseURL?: string }>({
  getImage (src, { modifiers = {}, baseURL = 'https://media.gokonfetti.com/' }) {
    let width = Number(modifiers?.width || 0)
    if (!width || Number.isNaN(width)) {
      width = WIDTH_RUNGS[WIDTH_RUNGS.length - 1]
    }

    width = snapToKonfettiWidth(width)

    const base = baseURL.replace(/\/$/, '')
    return {
      url: resolveKonfettiSrc(src.trim(), width, base),
    }
  },
})

function resolveKonfettiSrc (src: string, width: number, baseURL: string): string {
  const segment = `${width}x0`

  if (src.startsWith('http://') || src.startsWith('https://')) {
    const u = parseURL(src)
    const pathname = u.pathname || ''
    const m = pathname.match(WIDTH_SEGMENT)
    if (!m) {
      return src
    }
    const [, id, , filename] = m
    const host = u.host ? `${u.protocol}//${u.host}` : baseURL
    return joinURL(host, `/${id}/${segment}/${filename}`)
  }

  const pathname = src.startsWith('/') ? src : `/${src}`
  const m = pathname.match(WIDTH_SEGMENT)
  if (!m) {
    return joinURL(baseURL, pathname)
  }
  const [, id, , filename] = m
  return joinURL(baseURL, `/${id}/${segment}/${filename}`)
}
